module.exports = __webpack_public_path__ + "static/img/6.3a1b3d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/6.png
// module id = I3gQ
// module chunks = 0